import React from "react";
import { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";

export default function UpcommingFixture() {
  const { t, i18n } = useTranslation();
  const [upcomingFixtureList, setUpcomingFixtureList] = useState([]);

  useEffect(() => {
    getAPI();
  }, []);

  const getAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/upcomingEvent`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        setUpcomingFixtureList(paresData.upcomingEventdata)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formatDatefromAPI = (isoDate) => {
    const date = new Date(isoDate);

    // Get date components
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();

    // Get time components in UTC+05:30 (Indian Standard Time)
    const options = { timeZone: "Asia/Kolkata", hour12: false };
    const timeString = date.toLocaleTimeString("en-GB", options); // 24-hour format HH:mm:ss

    // Get the UTC offset (+05:30)
    const offset = date.getTimezoneOffset(); // Returns offset in minutes
    const offsetHours = String(Math.abs(offset) / 60).padStart(2, "0");
    const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, "0");
    const offsetSign = offset > 0 ? "-" : "+";

    return `${day}/${month}/${year} ${timeString} (UTC${offsetSign}${offsetHours}:${offsetMinutes})`;
};

  const getImageClass = (sportId) => {
    if (sportId === "1") {
       return 'd-icon icon-1';
    }else if (sportId === "4") {
       return 'd-icon icon-4';
    }else if (sportId === "2") {
       return 'd-icon icon-2';
    }else if (sportId === "400") {
       return 'd-icon icon-66';
    }else if (sportId === "500") {
      return 'd-icon icon-40';
    }else if (sportId === "4339") {
      return 'd-icon icon-65';
    }else if (sportId === "7") {
      return 'd-icon icon-10';
    }else{
       return 'd-icon icon-4';
    }
 }

  return (
    <div className="sidebar-box upcoming-fixure">
      <div className="sidebar-title"> {t('UpcomingFixure')} </div>
      <div className="sidebar-content">
        <Swiper
          direction={"vertical"}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          className="mySwiper"
        >
  {upcomingFixtureList && upcomingFixtureList?.length > 0 ? 
          upcomingFixtureList?.map((item,index)=>(
            <SwiperSlide key={index}>
            <Link to={`/exchange_inPlay/${item.eventId}`}>
              <div className="fixure-box">
                <div className="title">
                  <i className={`${getImageClass(item.sportId)}`}></i> {item.eventName}
                </div>
                <div className="time">{formatDatefromAPI(item.openDate)}</div>
              </div>
            </Link>
          </SwiperSlide>
          )) : <SwiperSlide>No Upcoming Events.</SwiperSlide>}
        </Swiper>
      </div>
    </div>
  );
}
